import { forwardRef } from 'react';

import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import {
  MenuListContent,
  MenuListRoot,
  MenuListTrigger,
  Text,
  UnstyledButton,
  usePreventScroll,
} from '@myrealtrip/web-ui';

import Show from '~components/Show';
import { useDetermineMobile } from '@myrealtrip/device-detect';

import TravelerAgeSelectorOptionList from './TravelerAgeSelectorOptionList';

interface Props {
  index: number;
  travelerAge: number;
  selectedTraveler?: { index: number; age: number } | null;
  viewSelectedTravelerAge: boolean;
  onClickTrigger: (index: number) => () => void;
  onClickOption: (index: number, age: number) => () => void;
}

const TravelerAgeSelector = forwardRef<HTMLDivElement, Props>(
  (
    {
      index,
      travelerAge,
      selectedTraveler,
      viewSelectedTravelerAge,
      onClickTrigger,
      onClickOption,
    },
    containerRef,
  ) => {
    const { colors } = useTheme();
    const isMobile = useDetermineMobile();

    const { index: selectedIndex, age: selectedAge } = selectedTraveler ?? {};
    const isOpen =
      !isMobile && selectedAge !== undefined && viewSelectedTravelerAge && selectedIndex === index;

    usePreventScroll({ isDisabled: !isOpen });

    return (
      <MenuListRoot isOpen={isOpen}>
        <MenuListTrigger>
          <AgeButton disabled={viewSelectedTravelerAge} onClick={onClickTrigger(index)}>
            <Text typography="paragraphBold15" color={colors.gray.s1000}>
              만 {travelerAge} 세
            </Text>
          </AgeButton>
        </MenuListTrigger>
        <MenuListContent>
          <Show when={isOpen}>
            <OptionListContainer ref={containerRef}>
              <TravelerAgeSelectorOptionList
                travelerIndex={index}
                selectedAge={selectedAge}
                onClickOption={onClickOption}
              />
            </OptionListContainer>
          </Show>
        </MenuListContent>
      </MenuListRoot>
    );
  },
);

TravelerAgeSelector.displayName = 'TravelerAgeSelector';

const AgeButton = styled(UnstyledButton)`
  width: 90px;
  height: 40px;
  border-radius: 999px;
  background-color: white;
  cursor: pointer;
`;

const OptionListContainer = styled.div``;

export default TravelerAgeSelector;
